module.exports = __webpack_public_path__ + "static/media/double-arrow-left.ec54a7c0.svg";